import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import z from "zod";

// src/models/subscription.ts
let SubscriptionStatus = /* @__PURE__ */ function(SubscriptionStatus) {
	SubscriptionStatus["Inactive"] = "inactive";
	SubscriptionStatus["Active"] = "active";
	SubscriptionStatus["Expired"] = "expired";
	return SubscriptionStatus;
}({});
const stripeSubscriptionStatusSchema = z.enum([
	"active",
	"past_due",
	"trialing",
	"canceled",
	"incomplete",
	"incomplete_expired",
	"paused",
	"unpaid"
]);
const subscriptionInfoSchema = z.object({
	id: z.string().nullable(),
	status: z.enum(Object.values(SubscriptionStatus)),
	stripeStatus: stripeSubscriptionStatusSchema.optional(),
	billingCycleAnchor: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date()).nullable().optional(),
	pendingInvoiceItemInterval: z.enum([
		"day",
		"month",
		"week",
		"year"
	]).nullable().optional(),
	lastPeriodEnd: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date()).nullable().optional(),
	lastPeriodStart: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date()).nullable().optional(),
	automaticallyRenewing: z.boolean().optional(),
	stripeProductId: zodFlavorId().nullable().optional()
});
const oneTimeInfoSchema = z.object({ status: z.enum(["active", "inactive"]) });
const subscriptionListItemSchema = subscriptionInfoSchema.extend({
	id: z.string(),
	stripeCreatedAt: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date())
});
const subscriptionSchema = z.object({
	id: zodFlavorId(),
	customerId: zodFlavorId(),
	type: z.enum(["subscription", "payment"]),
	subscriptionInfo: subscriptionInfoSchema.optional(),
	subscriptionInfoList: z.array(subscriptionListItemSchema).optional(),
	oneTimeInfo: oneTimeInfoSchema.optional()
}).refine((data) => data.id === data.customerId, {
	message: "Document ID and customerId must match",
	path: ["id", "customerId"]
});
/**
* Subscriptions collection definition
* Path: subscriptions/{customerId}
*/
const Subscriptions = defineFirestoreCollection("subscriptions", subscriptionSchema, void 0, {
	dwReplication: true,
	firestoreCollectionPath: "subscriptions"
});

export { SubscriptionStatus, Subscriptions, oneTimeInfoSchema, stripeSubscriptionStatusSchema, subscriptionInfoSchema, subscriptionListItemSchema, subscriptionSchema };
//# sourceMappingURL=subscription.mjs.map